var map = {
	"./sprite-00.png": 254,
	"./sprite-01.png": 255,
	"./sprite-02.png": 256,
	"./sprite-03.png": 257,
	"./sprite-04.png": 258,
	"./sprite-05.png": 259,
	"./sprite-06.png": 260,
	"./sprite-07.png": 261,
	"./sprite-08.png": 262,
	"./sprite-09.png": 263,
	"./sprite-10.png": 264,
	"./sprite-11.png": 265,
	"./sprite-12.png": 266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 253;